// @ts-nocheck
// client/src/v2/convite-landing.tsx
// ────────────────────────────────────────────────────────────────────────
// Landing de /r/:codigo — a tela que quem foi convidado vê primeiro.
//
// Antes disto o link funcionava (capturava o código, vinculava depois do
// cadastro) mas a pessoa caía na tela de cadastro comum, sem nenhum sinal
// de que tinha sido convidada. O convite é o momento de maior intenção do
// funil e chegava mudo.
//
// O que a tela mostra, e por quê:
//   · QUEM convidou, com avatar e nome — é o ativo do convite. "Wesley te
//     convidou" carrega a confiança que uma landing anônima não tem.
//   · grátis, SEM CARTÃO — é o que destrava a decisão (o app é grátis desde 14/10/2026).
//   · Que a pessoa entrou por convite. Até 14/09/2026 a linha dizia que
//     isso valia desconto; a campanha acabou e a promessa saiu (02/10).
//
// Se já houver sessão, esta tela não aparece: o vínculo acontece sozinho e
// a pessoa segue para o app.
// ────────────────────────────────────────────────────────────────────────
import React, { useEffect, useState } from 'react';
import { Icon } from './icons';

export const ConviteLandingScreen: React.FC<{
  code: string;
  onCriarConta: () => void;
  onEntrar: () => void;
}> = ({ code, onCriarConta, onEntrar }) => {
  const [dados, setDados] = useState<any>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let vivo = true;
    fetch('/api/public/referrals/' + encodeURIComponent(code))
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (vivo) setDados(j && j.valido ? j : null); })
      .catch(() => {})
      .finally(() => { if (vivo) setCarregando(false); });
    return () => { vivo = false; };
  }, [code]);

  const nome = dados?.quemIndicou?.nome || null;
  const avatar = dados?.quemIndicou?.avatar || null;
  const inicial = (nome || '?').trim().charAt(0).toUpperCase();

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--paper)',
      display: 'flex', flexDirection: 'column',
      padding: 'calc(28px + env(safe-area-inset-top,0px)) 24px calc(28px + env(safe-area-inset-bottom,0px))',
    }}>
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center',
        maxWidth: 420, width: '100%', margin: '0 auto',
        animation: 'e2FadeUp .4s ease both',
      }}>

        {/* ── quem convidou ────────────────────────────────────────── */}
        {carregando ? (
          <div style={{ height: 74 }} />
        ) : nome ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 13, marginBottom: 26 }}>
            <span style={{
              width: 52, height: 52, borderRadius: '50%', flexShrink: 0,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: avatar ? `url(${avatar}) center/cover` : 'var(--ember-soft)',
              color: 'var(--ember)', fontSize: 21, fontWeight: 700,
              border: '1px solid var(--line)',
            }}>{!avatar && inicial}</span>
            <div style={{ minWidth: 0 }}>
              <div className="mono" style={{
                fontSize: 9.5, letterSpacing: '0.16em', textTransform: 'uppercase',
                color: 'var(--ember)', fontWeight: 600,
              }}>convite</div>
              <div style={{
                fontSize: 17, color: 'var(--ink)', marginTop: 3, lineHeight: 1.25,
              }}>
                <strong style={{ fontWeight: 600 }}>{nome}</strong> te convidou
              </div>
            </div>
          </div>
        ) : (
          // Código inválido ou expirado: não trava a pessoa nem explica o
          // problema dela — só some com a parte do convite e segue com o
          // cadastro normal, que é o que ela veio fazer.
          <div style={{ height: 12 }} />
        )}

        {/* ── a promessa ───────────────────────────────────────────── */}
        <h1 className="serif" style={{
          margin: 0, fontSize: 38, lineHeight: 1.06, color: 'var(--ink)', fontWeight: 400,
        }}>
          Vire a pessoa<br />que lê — <i style={{ color: 'var(--ember)' }}>e lembra</i>.
        </h1>

        <p style={{
          margin: '18px 0 0', fontSize: 16, lineHeight: 1.55, color: 'var(--ink-2)',
        }}>
          Você compra livros e eles ficam parados. Começa e abandona.
          O Forjamente muda isso — e é grátis, sem cartão.
        </p>

        {/* ── o que a pessoa ganha, sem virar página de venda ──────── */}
        <div style={{
          marginTop: 22, padding: '16px 18px', borderRadius: 18,
          background: 'var(--paper-2)', border: '1px solid var(--line)',
        }}>
          {[
            ['O app inteiro, de graça', 'sem cartão, sem prazo'],
            ['Um protocolo pra criar o hábito', 'uma página vence o dia'],
            // O desconto por indicação acabou em 14/09/2026 (paywall.tsx: temDesconto
            // = false). A linha prometia "isso vale desconto quando decidir
            // assinar", e a promessa não se cumpria no paywall. O convite fica.
            nome ? ['Você entrou por convite', `a convite de ${nome}`] : null,
          ].filter(Boolean).map(([t, sub]: any, i: number, arr: any[]) => (
            <div key={i} style={{
              display: 'flex', gap: 11, alignItems: 'flex-start',
              paddingBottom: i < arr.length - 1 ? 13 : 0,
              marginBottom: i < arr.length - 1 ? 13 : 0,
              borderBottom: i < arr.length - 1 ? '1px solid var(--line)' : 'none',
            }}>
              <span style={{ marginTop: 1, flexShrink: 0 }}>
                <Icon name="check" size={15} color="var(--ember)" stroke={2.4} />
              </span>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 14.5, color: 'var(--ink)', lineHeight: 1.35 }}>{t}</div>
                <div style={{ fontSize: 12.5, color: 'var(--ink-3)', marginTop: 2, lineHeight: 1.4 }}>{sub}</div>
              </div>
            </div>
          ))}
        </div>

        {/* ── ação ─────────────────────────────────────────────────── */}
        <button onClick={onCriarConta} style={{
          marginTop: 24, width: '100%', padding: '17px 18px', borderRadius: 16,
          background: 'var(--ember)', color: 'var(--paper)', border: 'none',
          fontSize: 16.5, fontWeight: 700, cursor: 'pointer',
          boxShadow: '0 14px 30px -12px rgba(232,122,59,0.55)',
        }}>Criar minha conta</button>

        <button onClick={onEntrar} style={{
          marginTop: 11, width: '100%', padding: '13px', borderRadius: 999,
          background: 'transparent', border: 'none',
          color: 'var(--ink-3)', fontSize: 14, cursor: 'pointer',
        }}>Já tenho conta</button>

        <p style={{
          margin: '20px 0 0', fontSize: 11.5, lineHeight: 1.5,
          color: 'var(--ink-4)', textAlign: 'center',
        }}>
          O app é grátis. Nada é cobrado.
        </p>
      </div>
    </div>
  );
};

export default ConviteLandingScreen;
